<template>
	<div class="innerBox">
		<h1 class="mb-3">Balance Sheet</h1>
  
      	<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox" style="padding:0%">
				<div class="col row">
					<!-- <div class="col-md-3 col-12 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Bulan</label>
						<Multiselect 
							v-if="options.month"
							:options="options.month.map(x => x.value)"
							:custom-label="opt => options.month.find(x => x.value == opt)"
							v-model="selected.month"
							:allow-empty="false"
						/>
					</div> -->
					<div class="col-md-3 col-12 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tahun</label>
						<Multiselect 
							:options="options.year"
							v-model="selected.year"
							:allow-empty="false"
						/>
					</div>
					<div class="offset-md-3 col-md-3 col-12 mt-1" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
					<button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="update++">Filter</button>
					</div>
				</div>
			</div>
      	</panel>

		<div class="row mt-3">
			<div class="col-md-2 offset-md-10 col-sm-4 offset-sm-8 col-6 offset-6">
				<button class="btn btn-info w-100" @click="print">Print</button>
			</div>
		</div>

		<div class="mt-3 shadow rounded " id="printMe">
			<div v-if="data && companyDetail" class="pt-3 pb-3">
				<div class="text-center">
					<h4>{{companyDetail.fullname.toUpperCase()}}</h4>
					<h4>BALANCE SHEET</h4>
					<h4>Year {{filter.year}}</h4>
				</div>

				<div class="row pl-4 pr-4 mt-4">
					<div class="col-md-6 col-12 mt-2 pl-5 pr-5">
						<h4>Assets</h4>
						<hr>

						<div class="row" v-for="(dat, index) in data.filter(x => x.account_type == 'ASSET')" :key="index">
							<div class="col-6">
								<h6>{{dat.name}}</h6>
							</div>
							<div class="col-6 text-right">
								<h6>{{numberWithCommas(Math.abs(dat.sum))}}</h6>
							</div>
						</div>

						
					</div>
					<div class="col-md-6 col-12 mt-2 pl-5 pr-5">
						<h4>Liabilities</h4>
						<hr>

						<div class="row" v-for="(dat, index) in data.filter(x => x.account_type == 'LIABILITIES')" :key="index">
							<div class="col-6">
								<h6>{{dat.name}}</h6>
							</div>
							<div class="col-6 text-right">
								<h6>{{numberWithCommas(Math.abs(dat.sum))}}</h6>
							</div>
						</div>

						
					</div>

					
				</div>
				<!-- <div class="row mt-5 pl-4 pr-4">
					<div class="col-6 row pl-5 pr-5">
						<div class="col-6">
							<h4>Total Assets</h4>
						</div>
						<div class="col-6 text-right">
							<h4>{{sum(data.filter(x => x.account_type == 'ASSET').map(x => Math.abs(x.sum)))}}</h4>
						</div>
					</div>
					<div class="col-6 row pr-2">
						<div class="col-6">
							<h4>Total Liabilities</h4>
						</div>
						<div class="col-6 text-right">
							<h4>{{sum(data.filter(x => x.account_type != 'ASSET').map(x => Math.abs(x.sum)))}}</h4>
						</div>
					</div>
				</div> -->

				<div class="row pl-4 pr-4 mt-4">
					<div class="col-12 mt-2 pl-5 pr-5">
						<h4>Summary</h4>		
						<hr>
						<div class="row">
							<div class="col-md-3 col-sm-6 col-12">
								<h5>Total Assets</h5>
							</div>
							<div class="col-md-3 col-sm-6 col-12">
								<h5>{{sum(data.filter(x => x.account_type == 'ASSET').map(x => Math.abs(x.sum)))}}</h5>
							</div>
						</div>

						<div class="row">
							<div class="col-md-3 col-sm-6 col-12">
								<h5>Total Liabilities</h5>
							</div>
							<div class="col-md-3 col-sm-6 col-12">
								<h5>{{sum(data.filter(x => x.account_type == 'LIABILITIES').map(x => Math.abs(x.sum)))}}</h5>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div v-else class="pt-5 pb-5">
				<h4 class="text-center">Loading....</h4>
			</div>
		</div>
		  

	</div>
</template>

<script>
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
	components : {
		Multiselect
	},
	data () {
		let month = new moment().month()
		let year = new moment().year()

		return {
			options : this.$store.getters.getFilterOptions,
			filter : {
				year : year,
				month : month
			},
			selected : {
				year : year,
				month : month
			},
			mobile : this.isMobile(),
			update : 0,
			data : null,
			moment,
			companyDetail : null
		}
	},
	mounted () {
		this.loadData()
		this.getCompanyDetail()
	},
	watch : {
		update : function () {
			this.filter.year = this.selected.year
			this.filter.month = this.selected.month

			this.loadData()
		}
	},
	methods : {
		print(){
			this.$htmlToPaper('printMe');
		},
		getCompanyDetail() {
			this.$http.get('/api/v1/company_profile')
			.then((resp)=>{
				this.companyDetail = resp.data.data;
			})
			.catch((err)=>{console.log(err);})
		},
		loadData() {
			this.$http.get(`/api/v1/transactions/balance-sheet?month=${this.filter.month}&year=${this.filter.year}`)
			.then((resp) => {
				this.data = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		sum(data) {
			let total = 0

			for(var i = 0 ; i < data.length ; i++) {
				total += data[i]
			}

			return this.numberWithCommas(total)
		}
	}
}
</script>